import { IonIcon } from "@ionic/react";
import { t } from "i18next";
import { pinOutline } from "ionicons/icons";
import React from "react";

export const PinnedIcon = (props: any) => (
  <IonIcon
    icon={pinOutline}
    title={t("pinnedChannel") || ""}
    style={{
      color: "#ba372a",
    }}
    className={props.className}
  />
);
